module.exports = "../../app/cells/components/modals/questions_review_instructions_modal_cell.rb";